import React from 'react';
import HeroSection from '@anonymizePro/components/hero-section';
import WhatWeOffer from '@anonymizePro/components/what-we-offer';
import Feature from '@anonymizePro/components/feature';
import TestimonialsPricing from '@anonymizePro/components/testimonials-pricing';
import UseCases from '@anonymizePro/components/use-cases';
import TrustedBy from '@anonymizePro/components/trusted-by';
import Demonstration from '@anonymizePro/components/talk-to-expert';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

function AnonymizePro() {
    return (
        <main className={`min-h-calc-72 flex flex-col items-center bg-white text-[60px] font-bold`}>
            <HeroSection />
            <WhatWeOffer />
            <Feature />
            <TestimonialsPricing />
            <UseCases />
            <TrustedBy />
            <Demonstration />
        </main>
    );
}

export async function getServerSideProps({ locale }: any) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'], null, ['en', 'nl']))
        }
    };
}

export default AnonymizePro;
